import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import { LoanDetails } from '../../loan-gtm-interface/loan-gtm.interface';
import mixpanel from "mixpanel-browser/src/loader-module";
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HeaderInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
import { convert } from 'currency-in-words';
declare let gtag: Function;

@Component({
  selector: 'fa-loan-details-form',
  templateUrl: './loan-details-form.component.html',
  styleUrls: ['./loan-details-form.component.scss']
})
export class LoanDetailsFormComponent implements OnInit, AfterViewInit {
  @ViewChild("openErrorPopup") openErrorPopup;
  @ViewChild('content') content;
  @ViewChild('loanAmountErrorMobile') loanAmountErrorMobile!: ElementRef<HTMLDivElement>;
  model: any = {};
  commaLoanAmount: string;
  modelName: any;
  isMobile: boolean = false;
  isPartnerLink: boolean = false;
  partnerLogo: string;
  showLoanAmountInput: boolean = true;
  userData: {};
  isIndianNumber: boolean = true;
  currencyValue: 'INR' | 'USD' | 'GBP' | 'CAD' = 'INR';
  currencyOptions: any[] = this.configService.getConfig1("foreignAssist", "loanCurrencyOptions");
  loanWidgetConfig: any = this.configService.getConfig1("loanWidgetConfig");
  steps = this.loanWidgetConfig.loanDetailsStepperConfig;
  currencyExchangeRates: any = this.configService.getConfig1("foreignAssist", "currencyExchangeRates")
  @ViewChild('calculateLoan') calculateLoan
  layout: FormlyFieldConfig[];
  step: String = 'firstStep';

  showLoanType: boolean = false;
  configLoanAmountHeader: HeaderInterface = {
    title: "How much loan do you need?",
    back: {
      link: '/academic-details',
      step: 'thirdStep'
    }
  }

  orientation: String;
  showNumberToWords: any;

  constructor(
    private route: Router,
    public loanService: LoanGtmService,
    private apiHelper: ApiHelperService,
    private breakpointObserver: BreakpointObserver,
    private userIdentity: UserIdentityService,
    private activatedRoute: ActivatedRoute,
    private configService: ConfigService,
    private modalService: NgbModal
  ) {

  }

  identify(user_id, userData = {}) {
    mixpanel.identify(user_id, userData)
  }

  trackEvent(event, data = {}) {
    mixpanel.track(event, data)
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.orientation = 'vertical';
        } else {
          this.orientation = 'horizontal';
        }
      });

    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
      mixpanel.init('36f7bc976b3c6dc024e372be5c7d26f8'); //change the token as per environment
    }
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {

      localStorage.setItem('puid', puid);
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }

    }
    this.checkUserLoggedIn();
    if (this.loanService?.studentDetails?.countryCode !== '+91' && !(this.loanService?.studentDetails?.universityVendors?.includes('mpower') || this.loanService?.studentDetails?.universityVendors?.includes('prodigy'))) {
      this.showLoanAmountInput = false;
    }

  }

  getPartnerDetails(partnerUid) {
    this.apiHelper.getDataById("users/partner", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response };
      if (partnerDetails) {
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
      }
      else {
        this.isPartnerLink = false;
      }
    })
  }

  checkUserLoggedIn() {
    if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['']);
      return;
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/personal-details']);
      return;
    }
  }

  ngAfterViewInit(): void {
    if (this.loanService?.loanDetails) {
      this.dataPreprocessor();
    }
    if (document) {
      let p = document.getElementById("error-tag");
      if (p) {
        p.style.display = 'none';
      }
    }

    this.loanAmountErrorMobile.nativeElement.style.visibility = 'hidden';
  }

  dataPreprocessor() {
    this.loanService.getLoanApplication(this.loanService.studentDetails?.id).then((data: any) => {
      this.isIndianNumber = this.loanService.isMobileIndian(this.loanService?.studentDetails?.mobile);
      if (data?.length > 0) {
        let nullRemoved = this.removeEmpty(data[0]);
        this.loanService.saveLoanApplication(nullRemoved);
        this.model = { ... this.loanService?.loanDetails };
      }
      else {
        this.model = { ... this.loanService?.loanDetails };
      }
      if (this.isIndianNumber) {
        if (!this.model?.loanAmountCurrency) {
          this.model.loanAmountCurrency = "INR";
        }
      }
      else {
        this.currencyOptions = this.currencyOptions.filter((single) => single?.value != 'INR');
        if (!this.model?.hasOwnProperty("loanAmountCurrency")) {
          this.model.loanAmountCurrency = "USD";
        }
      }
      this.setLayout();
      this.createCommaSeperatedAmount(this.model?.loanAmount);

      if (this.model?.loanAmount > 0) {
        this.showLoanType = true;
        this.numToWord(this.model?.loanAmount)
      }
      else {
        this.showLoanType = false;
      }
    })
  }

  setLayout() {
    this.layout = [
      {
        fieldGroupClassName: "row loanCurrency-custom",
        fieldGroup: [
          {
            className: "col-12 loanCurrency",
            key: "loanAmountCurrency",
            type: "select-new",
            templateOptions: {
              options: this.currencyOptions,
              required: true,
              click: (event: any) => {
                this.checkLoanAmountValue(event.target.value)
              }
            },

          }
        ]
      }
    ]
  }

  createCommaSeperatedAmount(amount: any) {
    if (amount) {
      this.commaLoanAmount = (Number((amount).replaceAll(",", ""))).toLocaleString('en-IN', {
        maximumFractionDigits: 2,
        currency: 'INR'
      }).replace("$", "").split(".")[0];
    }
  }

  inrLoanAmount(event) {
    if (event) {
      if (event.target.value > 0) {
        this.showLoanType = true;
      }
      else {
        this.showLoanType = false;
      }

      this.numToWord(event?.target?.value)
      let loanAmount: any;
      if (this.model?.loanAmountCurrency !== "INR") {
        this.model.loanAmount = (event.target.value).replaceAll(",", "")
        loanAmount = (Number((event.target.value).replaceAll(",", "")) * this.currencyExchangeRates[this.model?.loanAmountCurrency]);
        if (typeof window === "object") {
          this.commaLoanAmount = (Number((this.model.loanAmount).replaceAll(",", ""))).toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            currency: 'INR'
          }).replace("$", "").split(".")[0];
        }
      }
      else {
        this.model.loanAmount = (event.target.value).replaceAll(",", "");
        loanAmount= (event.target.value).replaceAll(",", "");
        if (typeof window === "object") {
          this.commaLoanAmount = (Number((this.model.loanAmount).replaceAll(",", ""))).toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            currency: 'INR'
          }).replace("$", "").split(".")[0];
        }
      }
      if (Number(loanAmount) > 30000000 || Number(loanAmount) < 700000) {
        if (this.orientation === 'horizontal') {
          this.showNumberToWords = false;
          if (this.loanAmountErrorMobile?.nativeElement) {
            this.loanAmountErrorMobile.nativeElement.style.visibility = 'visible';
          }
        }
        else {
          this.showNumberToWords = false;
          if (this.loanAmountErrorMobile?.nativeElement) {
            this.loanAmountErrorMobile.nativeElement.style.visibility = 'visible';
          }
        }
      }
      else {
        if (this.orientation === 'horizontal') {
          if (this.loanAmountErrorMobile?.nativeElement) {
            this.loanAmountErrorMobile.nativeElement.style.visibility = 'hidden';
          }
        }
        else {
          if (this.loanAmountErrorMobile?.nativeElement) {
            this.loanAmountErrorMobile.nativeElement.style.visibility = 'hidden';
          }
        }
      }
    }
  }
  checkLoanAmountValue(event: any) {
    let loanAmount: any;
    if (event !== "INR") {
      loanAmount = (Number((this.model.loanAmount)) * this.currencyExchangeRates[event]);
      if (typeof window === "object") {
        this.commaLoanAmount = (Number((this.model.loanAmount))).toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          currency: 'INR'
        }).replace("$", "").split(".")[0];
      }
    }
    else {
      loanAmount = this.model.loanAmount
      if (typeof window === "object") {
        this.commaLoanAmount = (Number((this.model.loanAmount))).toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          currency: 'INR'
        }).replace("$", "").split(".")[0];
      }
    }
    this.numToWord(this.model.loanAmount)
    if (Number(loanAmount) > 30000000 || Number(loanAmount) < 700000) {
      if (this.orientation === 'horizontal') {
        this.showNumberToWords = false;
        if (this.loanAmountErrorMobile?.nativeElement) {
          this.loanAmountErrorMobile.nativeElement.style.visibility = 'visible';
        }
      }
      else {
        this.showNumberToWords = false;
        if (this.loanAmountErrorMobile?.nativeElement) {
          this.loanAmountErrorMobile.nativeElement.style.visibility = 'visible';
        }
      }
    }
    else {
      if (this.orientation === 'horizontal') {
        if (this.loanAmountErrorMobile?.nativeElement) {
          this.loanAmountErrorMobile.nativeElement.style.visibility = 'hidden';
        }
      }
      else {
        if (this.loanAmountErrorMobile?.nativeElement) {
          this.loanAmountErrorMobile.nativeElement.style.visibility = 'hidden';
        }
      }
    }
  }

  typeOfLoan(loanType: string) {
    if (!this.model.hasOwnProperty("loanAmount")) {

      if (document) {
        let p = document.getElementById("error-tag");
        if (p) {
          p.style.display = 'block';
        }
        this.modalService.open(this.openErrorPopup, {
          centered: true,
          size: 'l'
        })
        //this.apiHelper.openSnackBar("Please check the required fields that are missing.");
      }
      return;
    }
    else {
      if (!(this.model?.loanAmount?.length > 0)) {
        let p = document.getElementById("error-tag");
        if (p) {
          p.style.display = 'block';
        }
        this.modalService.open(this.openErrorPopup, {
          centered: true,
          size: 'l'
        })
        //   this.apiHelper.openSnackBar("Please check the required fields that are missing.");
        return;
      }
      else {
        let loanAmountConverted = this.model?.loanAmount;
        if(this.model?.loanAmountCurrency === "USD"){
          loanAmountConverted = this.model?.loanAmount * this.currencyExchangeRates["USD"];
        }
        else if(this.model?.loanAmountCurrency === "CAD"){
          loanAmountConverted = this.model?.loanAmount * this.currencyExchangeRates["CAD"];
        }
        else if(this.model?.loanAmountCurrency === "GBP"){
          loanAmountConverted = this.model?.loanAmount * this.currencyExchangeRates["GBP"];
        }
        else if(this.model?.loanAmountCurrency === "EUR"){
          loanAmountConverted = this.model?.loanAmount * this.currencyExchangeRates["EUR"];
        }

        if (Number((loanAmountConverted) > 30000000 || Number(loanAmountConverted) < 700000) ) {
          let loanError = document.getElementById("loan-amount-error");
          if (loanError) {
            loanError.style.display = 'block';
          }
          //this.apiHelper.openSnackBar("We can arrange funds upto 3cr inclusive of Tuition fees & Living expenses");
          return;
        }
        else if(Number((this.model?.loanAmount * 85) > 30000000 || Number(this.model?.loanAmount * 85) < 700000) && this.model?.loanAmountCurrency === "USD"){

        }
      }
    }

    let loanApplication: LoanDetails
    loanApplication = {
      loanAmount: this.model.loanAmount,
      loanAmountCurrency: this.model.loanAmountCurrency,
      loanType: loanType,
      status: "applied",
      callStatus: "NOT_CALLED",
      studentId: this.loanService.studentDetails?.id,
      appliedVia: "widget"
    }

    this.loanService.saveLoanApplication(loanApplication).then(() => {
      if (loanType === 'Secured Loan(with Property)') {
        if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('qa') && !window.location.host.includes('uat')) {
          this.userData = {
            source: "Loan Widget",
          }
          if (this.loanService.partnerDetails) {
            this.userData["PartnerName"] = this.loanService.partnerDetails?.company?.name;
          }
          this.trackEvent("Choose button of Secured Loan(with Property) on Loan Widget  clicked", this.userData)
        }
        this.loanService.createLoanApplication(loanApplication).then((data) => {
          if (data?.data) {
            delete data?.data
          }
          this.loanService.saveLoanApplication(data);

          if (this.isPartnerLink) {
            this.route.navigate(['collateral-type/' + this.loanService?.partnerDetails?.uid]);
            return;
          }
          this.route.navigate(['collateral-type']);
        });
      }
      else if (loanType === 'Unsecured Loan(without Property)') {
        if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('qa') && !window.location.host.includes('uat')) {
          this.userData = {
            source: "Loan Widget",
          }
          if (this.loanService.partnerDetails) {
            this.userData["PartnerName"] = this.loanService.partnerDetails?.company?.name;
          }
          this.trackEvent("Choose button of Unsecured Loan(without Property) on Loan Widget clicked", this.userData)
        }
        this.loanService.createLoanApplication(loanApplication).then((data) => {
          if (data?.data) {
            delete data?.data
          }
          this.loanService.saveLoanApplication(data);
          if (this.isPartnerLink) {
            this.route.navigate(['non-collateral-type/' + this.loanService?.partnerDetails?.uid]);
            return;
          }
          this.route.navigate(['non-collateral-type'])
        })
      }
      else {
        this.loanService.createLoanApplication(loanApplication).then(() => {
          this.loanService.updateLoanLeadToApplied();
          if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
            this.userData = {
              source: "Loan Widget",
            }
            if (this.loanService.partnerDetails) {
              this.userData["PartnerName"] = this.loanService.partnerDetails?.company?.name;
            }
            this.trackEvent("Choose button of International Loan(Non Collateral-Cosigner) on Loan Widget clicked", this.userData)
          }

          if (this.isPartnerLink) {
            this.route.navigate(['result/' + this.loanService?.partnerDetails?.uid]);
            return;
          }
          this.route.navigate(['result'])
        })
      }
    })

    gtag('event', 'loan_selection_submit', {
      'event_category': 'button',
      'event_label': 'Loan selection submit button',
      'value': "Loan selection information"  
    });

    gtag('config','G-LW5LDX8EDG',{
      'user_id': this.model?.mobile
    })

    sessionStorage.removeItem("stepHeading")

  }

  goBack() {
    this.modalService.dismissAll();
  }

  removeEmpty(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
      else if (typeof obj[propName] == 'object') {
        this.removeEmpty(obj[propName]);
      }
    }
    return obj
  }

  back() {
    if (this.isPartnerLink) {
      this.route.navigate(['academic-details/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['academic-details'])
  }

  logout() {
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  raiseARequest() {
    this.modalService.open(this.content, { centered: true });
    let loanRequest: any = {
      id: this.loanService?.studentDetails?.id,
      name: `${this.loanService.studentDetails?.firstName + " " + this.loanService.studentDetails?.lastName}`,
      email: this.loanService.studentDetails?.email,
      mobile: this.loanService.studentDetails?.mobile,
      loanType: this.loanService.loanDetails?.loanType
    };

    if (this.isPartnerLink) {
      loanRequest.partnerName = this.loanService?.partnerDetails?.name;
      loanRequest.showAgentCode = this.loanService?.partnerDetails?.company?.showAgentCode ? true : false
    }
    this.apiHelper.postData("send-loan-application-request", loanRequest).subscribe(() => {
      this.apiHelper.openSnackBar("Sent request Successfully!");
    })
  }

  emitStep(ev: any) {
    sessionStorage.setItem("stepHeading", "thirdStep")
    if (this.isPartnerLink) {
      this.route.navigate(["academic-details/" + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(["academic-details"]);

  }

  numToWord(inputNumber: any) {
    this.showNumberToWords = convert(inputNumber);
  }

  openModalCalculateLoan() {
    this.modalService.open(this.calculateLoan, { centered: true });
  }

}